"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUIElement = void 0;
const react_1 = require("react");
function createUIElement(name, render) {
    const result = (0, react_1.forwardRef)(render);
    result.displayName = name;
    result.selector = `.vm-${name}`;
    return result;
}
exports.createUIElement = createUIElement;
//# sourceMappingURL=createUIElement.js.map